<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="商品板块设置"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="100px"
      :form-rules="rules"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12" v-if="false">
            <!-- <el-form-item label="板块名称" prop="SectionId">
              <el-select v-model="data.SectionId" placeholder="请选择板块名称" clearable>
                <el-option v-for="item in listbk" :key="item.RecordId" :value="item.RecordId" :label="item.SectionName"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="板块名称" prop="SectionId">
              <el-input
                v-model="data.SectionId"
                placeholder="请填写板块名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="入口名称" prop="EntryTitle">
              <el-input
                v-model="data.EntryTitle"
                placeholder="请填写入口名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="链接类型" prop="EntryType">
              <el-select
                v-model="data.EntryType"
                placeholder="请选择链接类型"
                clearable
              >
                <el-option label="课程" :value="4"></el-option>
                <el-option label="宝物" :value="5"></el-option>
                <!-- <el-option label="商品标签" :value="2"></el-option>
                <el-option label="商品类别" :value="0"></el-option> -->
                <!-- <el-option label="固定分类" :value="1"></el-option> -->
                <!-- <el-option label="优惠活动" :value="3"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12" v-if="data.EntryType == 0">
            <el-form-item label="分类名称" prop="GoodstypeId">
              <tree-select
                ref="treeSelect"
                :clearable="false"
                :accordion="true"
                :parentSelect="true"
                :options="listGoodsType"
                placeholder="请选择商品分类名称"
                :props="typeprops"
                :value="data.GoodstypeId"
                @node-select="nodeselect($event)"
              ></tree-select>
              <!-- <el-select
                v-model="data.GoodstypeId"
                placeholder="请选择商品分类名称"
                clearable
                filterable
              >
                <el-option
                  v-for="item in listGoodsType"
                  :key="item.RecordId"
                  :value="item.RecordId"
                  :label="item.TypeName"
                ></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12" v-if="data.EntryType == 1">
            <el-form-item label="分类名称" prop="RegulartypeId">
              <el-select
                v-model="data.RegulartypeId"
                placeholder="请选择固定分类名称"
                clearable
              >
                <el-option label="最新商品" :value="0"></el-option>
                <el-option label="推荐商品" :value="1"></el-option>
                <el-option label="热销商品" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12" v-if="data.EntryType == 2">
            <el-form-item label="标签名称" prop="GoodslabelId">
              <el-select
                v-model="data.GoodslabelId"
                placeholder="请选择标签名称"
                clearable
              >
                <el-option
                  v-for="item in listlabel"
                  :key="item.RecordId"
                  :value="item.RecordId"
                  :label="item.Name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12" v-if="data.EntryType == 3">
            <el-form-item label="活动类型" prop="ActivitytypeId">
              <el-select
                v-model="data.ActivitytypeId"
                placeholder="请选择活动类型名称"
                @change="activitytypechange"
                clearable
              >
                <el-option label="团购" :value="0"></el-option>
                <el-option label="秒杀" :value="1"></el-option>
                <el-option label="折扣" :value="2"></el-option>
                <el-option label="满送" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :span="isMB ? 24 : 12"
            v-if="data.ActivitytypeId >= 0 && data.EntryType == 3"
          >
            <el-form-item label="活动名称" prop="ActivityId">
              <el-select
                v-model="data.ActivityId"
                placeholder="请选择活动名称"
                clearable
                filterable
              >
                <el-option
                  v-for="item in listActivity"
                  :key="item.ActivityId"
                  :value="item.ActivityId"
                  :label="item.ActivityName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 
        <el-row>

           <el-col :span="24">
               <el-form-item label="电脑端图片上传" prop="IconAddress">
                      <single-pic-upload v-model="data.IconAddress" type="IconAddress" :uploadUrl="uploadUrl"></single-pic-upload>
               </el-form-item>
            </el-col>
        </el-row> -->

        <el-row>
          <el-col :span="24">
            <el-form-item label="标题图片" prop="IconAddressmobile">
              <single-pic-upload
                v-model="data.IconAddressmobile"
                type="IconAddressmobile"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
              <span style="color: red" v-if="data.ShowType == 0"
                >最佳长宽尺寸：360*125</span
              >
              <span style="color: red" v-if="data.ShowType == 1"
                >最佳宽长比例1：1</span
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="false">
          <el-col :span="24">
            <el-form-item label="展示模式" prop="ShowType">
              <el-radio-group v-model="data.ShowType">
                <el-radio :label="0">图片平铺</el-radio>
                <el-radio :label="1">图片半铺</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="false">
          <el-col :span="24">
            <el-form-item label="首页展示数量" prop="ShowCount">
              <el-input
                v-model="data.ShowCount"
                placeholder="请填写首页展示数量"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    treeSelect,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        SectionId: "",
        EntryTitle: "",
        IconAddress: "",
        EntryType: null,
        GoodstypeId: "",
        RegulartypeId: "",
        GoodslabelId: "",
        ActivitytypeId: "",
        ActivityId: "",
        OrderId: 0,
        ShowType: 0,
        ShowCount: 4,
        IconAddressmobile: null,
      },
      listbk: [],
      listlabel: [],
      listGoodsType: [],
      listActivity: [],
      api: require("@/api/mall/sectiongoods").default,
      api2: require("@/api/mall/section").default,
      api3: require("@/api/mall/label").default,
      gtypeapi: require("@/api/goods/typeplatform").default,
      isMB: this.$store.state.isMB,
      rules: {
        EntryTitle: [{ required: true, message: "入口名称不能为空" }],
        EntryType: [{ required: true, message: "链接类型不能为空" }],
        GoodstypeId: [{ required: true, message: "商品分类名称不能为空" }],
        RegulartypeId: [{ required: true, message: "固定分类名称不能为空" }],
        GoodslabelId: [{ required: true, message: "商品标签名称不能为空" }],
        ActivitytypeId: [{ required: true, message: "活动类型名称不能为空" }],
        ActivityId: [{ required: true, message: "活动类型名称不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
      typeprops: {
       value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  mounted() {
    this.getOption();
  },
  methods: {
    activitytypechange(val) {
      this.api2.getActivityTypeModel(val).then((res) => {
        this.listActivity = [];
        if (res.Code == 0) {
          if (res.Data && res.Data.length > 0) {
            this.listActivity = res.Data;
            var activity = res.Data.filter(
              (x) =>
                x.ActivitytypeId == this.data.ActivitytypeId &&
                x.ActivityId == this.ActivityId
            );
            console.log(activity, "activity");
            if (activity.length == 0) {
              this.data.ActivityId = "";
            }
          } else {
            this.data.ActivityId = "";
          }
        }
      });
    },
    getData(data) {
      this.api.list(data).then((res) => {
        //data就是从调用他的seciton\list.vue中传过来的sectionid,然后把这个参数再传到list接口，
        if (res.Code == 0) {
          //res.code=0表示调用成功，则判断是否数据值的长度大于0，有数据就大于0，则把提取到的数据赋值给当前的data
          if (res.Data && res.Data.length > 0) {
            this.data = res.Data[0];
            if (this.data.EntryType == 3) {
              this.api2
                .getActivityTypeModel(this.data.ActivitytypeId)
                .then((res) => {
                  this.listActivity = [];
                  if (res.Code == 0) {
                    if (res.Data && res.Data.length > 0) {
                      this.listActivity = res.Data;
                    } else {
                      this.data.ActivityId = "";
                    }
                  }
                });
            }
          } else {
            this.data.SectionId = data.SectionId; //把传入的参数data中的sectionId赋值给当前页面的data中的sectionid
          }
        }
      });
      this.getOption(); //因为是section列表界面用open打开，所以不会区调用onCreateOpened，所以需要把取标签数据下拉的放到这里才会触发。
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    // onCreateOpened(row) {
    //   this.getOption();

    // },
    onEditOpened(row) {
      this.getOption();
    },
    nodeselect(data) {
      console.log(data, "aa");
      if (data) this.data.GoodstypeId = data.RecordId;
      else this.data.GoodstypeId = null;
    },
    getOption() {
      this.loading(true);
      this.api2.list({ State: 1, SectionType: 2 }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.listbk = res.Data;
        }
      });
      this.api3.list({ State: 1, NotLabelIds: [4] }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.listlabel = res.Data;
        }
      });
      this.gtypeapi
        .list({
          State: 1,
          SortName: "OrderIdChain",
          SortOrder: "ASC",
        })
        .then((res) => {
          this.loading(false);
          if (res.Code == 0) {
            //this.listGoodsType = res.Data;
            console.log(this.$refs,"this.$refs");
            this.listGoodsType = this.$commonJs.toTreeData(
              res.Data,
              "RecordId",
              "TypeIdParent",
              "children"
            );
            if (this.$refs.treeSelect) {
            console.log(this.$refs.treeSelect,"this.$refs.treeSelect");
              this.$refs.treeSelect.setData();
            }
          }
        });
    },
    onBeforeSave() {
      var data = JSON.parse(JSON.stringify(this.data));
      if (data.ShowType == 1) {
        if (data.IconAddressmobile == "" || data.IconAddressmobile == null) {
          this.$message.warning("标题图片不能为空");
          return false;
        }
      }
    },
    onClosed() {
      this.listbk = [];
      this.listlabel = [];
      this.listActivity = [];
    },
  },
};
</script>